import { useEffect } from "react";
import { useUser } from "xAppLib/Hooks";
export function KioskModeActions() {
    var _a, _b;
    const user = useUser();
    const kiosk = Boolean((_b = (_a = user.prof) === null || _a === void 0 ? void 0 : _a.xtra) === null || _b === void 0 ? void 0 : _b.kiosk);
    useEffect(() => {
        if (kiosk) {
            document.body.classList.add("kiosk-mode");
            return () => {
                document.body.classList.remove("kiosk-mode");
            };
        }
    }, [kiosk]);
    return null;
}
